export default function(t,e,i,n,r){for(r in n=(i=i.split(".")).splice(-1,1),i)e=e[i[r]]=e[i[r]]||{};return t(e,n)};
//# sourceMappingURL=deepobj.m.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ranfdev/deepobj/dist/deepobj.m.js
// module id = nfAG
// module chunks = 0